import { ElvaLogoName } from '@ui';

import * as css from './GoalReportControls.css';

export type GoalReportControlsProps = {
    backButton: React.ReactNode;
};

export const GoalReportControls = ({ backButton }: GoalReportControlsProps) => {
    return (
        <header className={css.header}>
            <hgroup className={css.hgroup}>
                <ElvaLogoName width={120} />
            </hgroup>
            {backButton}
        </header>
    );
};
